import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import Selector from './Selector';
import Map from './Map';
import List from './List';

const Wrapper = styled.div`
  @media screen and (min-width: 321px) and (max-width: 750px) {
    padding: 0 15px;
    margin: ${({ viewJp }) => {
      if (viewJp === 'ja_jp') return '0 2%';
      return 0;
    }};
  }
  @media screen and (min-width: 751px) {
    padding: 0 15px;
    margin: ${({ viewJp }) => {
      if (viewJp === 'ja_jp') return '0 12%';
      return 0;
    }};
  }
`;

const Summary = styled.div`
  border-bottom: 2px solid #4a4a4a;
  margin: 0 15px;
  padding: 10px 0;

  @media (min-width: 900px) {
    margin: 0;
  }
`;

const Data = styled.div`
  display: flex;
  height: 65vh;
  position: relative;
`;

class ResultSection extends React.Component {
  state = {
    view: 'map',
    products: [],
  };

  componentDidMount = () => {
    this.getProductAll();
  };

  setView = view => {
    this.setState({ view });
  };

  setFocus = focus => {
    this.props.setFocus(focus);
    this.setView('map');
  };

  getProductAll = () => {
    const products = this.props.products.children;
    this.setState({
      products,
    });
  };

  render() {
    const { view, products } = this.state;
    const { address, coords, copy, focus, salons } = this.props;

    return (
      <Wrapper>
        <Summary>{`${salons.length} salons near ${address ? `"${address}"` : 'you'}`}</Summary>
        <Selector currentView={view} setView={this.setView} />
        <Data>
          <List
            show={view === 'list'}
            coords={coords}
            copy={copy}
            salons={salons}
            setFocus={this.setFocus}
            products={products}
          />
          <Map coords={coords} copy={copy} focus={focus} salons={salons} />
        </Data>
      </Wrapper>
    );
  }
}

ResultSection.defaultProps = {
  address: undefined,
  focus: -1,
};

ResultSection.propTypes = {
  address: PropTypes.string,
  coords: PropTypes.shape().isRequired,
  copy: PropTypes.shape().isRequired,
  focus: PropTypes.number,
  salons: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  setFocus: PropTypes.func.isRequired,
  products: PropTypes.shape().isRequired,
};

export default ResultSection;



// WEBPACK FOOTER //
// ./src/pages/SalonLocator/ResultSection/ResultSection.js